import React from "react";
import { motion } from "framer-motion";

const PURPLE_GRADIENT = "linear-gradient(0.68deg, #A28FDC 0.74%, #7C3AED 74.61%)";
const GOLD_GRADIENT   = "linear-gradient(94.06deg, #FFFE89 1.06%, #E9BF37 65.49%)";

const ThirtyDayCardMob = ({ car, onBook }) => {
  const rentPerDay = car.rentPerDay != null ? Number(car.rentPerDay) : null;
  const allottedKm = car.totalFreeKms;

  return (
    <motion.article
      layout
      className={`relative bg-white border-[0.6px] border-[#E5E7EB] rounded-[9px] shadow-[0px_6px_19.4px_-8.25px_rgba(212,184,184,0.07)] flex items-center justify-between gap-2 pl-3 pr-[13px] py-3 overflow-hidden min-w-0 ${car.isSoldOut ? "opacity-60" : ""}`}
    >
      {/* Gold "Subscription 👑" tag — top right */}
      <div
        className="absolute right-[-14.9px] top-[-11.4px] h-[32.26px] w-[138.73px] rounded-bl-[9.5px] rounded-br-[9.5px] rounded-tr-[9.5px] border-[1.2px] border-[#836B1E] drop-shadow-[0px_2.4px_6px_rgba(0,0,0,0.12)] pointer-events-none"
        style={{ backgroundImage: GOLD_GRADIENT, transform: "rotate(0.3deg)" }}
      >
        <span className="absolute left-[39.5px] top-[13.4px] -translate-x-1/2 text-[#46390C] text-[12px] font-medium font-['Outfit'] leading-[13.1px] tracking-[-0.36px] whitespace-nowrap">
          Subscription
        </span>
        <img
          src="/assets/icons/crown.svg"
          alt="crown"
          width={15.66}
          height={12.97}
          className="absolute left-[78px] top-[12.9px]"
        />
      </div>

      {/* Left: details */}
      <div className="flex flex-col gap-2 h-[155px] items-start shrink-0">
        {/* Name + body type */}
        <div className="flex flex-col gap-[5.5px] items-start w-full">
          <span className="text-[#252525] text-[16px] font-semibold font-['Outfit'] leading-[1.2] tracking-[0.3px] text-left">
            {car.name}
          </span>
          {car.bodyTypeText && (
            <span className="px-[6px] py-[1.5px] bg-[#F9FAFB] border-[0.8px] border-[#F3F3F9] rounded-[3.2px] text-[#1D4ED8] text-[10px] font-semibold font-['Outfit'] uppercase tracking-[0.75px] whitespace-nowrap">
              {car.bodyTypeText}
            </span>
          )}
        </div>

        {/* Specs pills */}
        <div className="flex items-center gap-[5.5px]">
          {[`${car.seater} Seats`, car.transmissionTypeText, car.fuelTypeText].map((spec, i) => (
            <span
              key={i}
              className="p-[5.5px] bg-[#F9FAFB] border-[0.7px] border-[#E5E7EB] rounded-[5.5px] text-[#111827] text-[10px] font-semibold font-['Outfit'] whitespace-nowrap"
            >
              {spec}
            </span>
          ))}
        </div>

        {/* Pricing + allotted km */}
        <div className="flex flex-col h-[75px] items-start justify-between w-[164px]">
          <div className="flex flex-col gap-[9px] items-start">
            {rentPerDay != null ? (
              <div className="flex items-end text-[#CD2525] whitespace-nowrap leading-none">
                <span className="text-[22px] font-bold font-['Outfit'] tracking-[-0.22px]">
                  ₹{rentPerDay.toLocaleString("en-IN")}
                </span>
                <span className="text-[13.4px] font-medium font-['Outfit'] tracking-[0.4px]">/day</span>
              </div>
            ) : (
              <div className="h-[22px]" />
            )}
            <p className="text-[#A2A2A2] text-[10.45px] font-medium font-['Outfit'] leading-[15px] tracking-[0.45px] text-left whitespace-nowrap">
              {car.baseFare != null && car.taxAmount != null && (
                <span>₹ {(Number(car.baseFare) + Number(car.taxAmount)).toLocaleString("en-IN")}/- </span>
              )}
              Incl. Taxes &amp; Excl. Fees
            </p>
          </div>
          <div className="flex items-center justify-center gap-2 border border-[#9B80DF] rounded-[6px] h-[23px] w-full text-[12px] whitespace-nowrap">
            <span className="text-[#404040] font-medium font-['Outfit'] tracking-[0.24px]">Allotted KM :</span>
            <span className="text-[#300F80] font-bold font-['Outfit']">{allottedKm ? `${allottedKm}KM` : "—"}</span>
          </div>
        </div>
      </div>

      {/* Right: image + Book Now */}
      <div className="relative flex flex-col items-end justify-between h-[146px] flex-1 min-w-0 max-w-[184px]">
        <div className="w-full h-[103px] mt-[4.5px]">
          <img
            src={car.imageUrl || "/assets/sample.png"}
            alt={car.name}
            className="w-full h-full object-contain"
            loading="lazy"
          />
        </div>
        <button
          disabled={car.isSoldOut}
          onClick={() => onBook(car)}
          className={`h-[28.4px] w-[95px] mr-2 rounded-[6px] text-[12px] font-medium font-['Outfit'] tracking-[0.32px] text-white border-[0.6px] whitespace-nowrap ${car.isSoldOut ? "bg-gray-200 text-gray-400 border-gray-200" : "border-[#6595FF] drop-shadow-[0px_8px_9.7px_rgba(26,86,219,0.2)]"}`}
          style={!car.isSoldOut ? { backgroundImage: PURPLE_GRADIENT } : undefined}
        >
          {car.isSoldOut ? "Sold Out" : "Book Now"}
        </button>
      </div>
    </motion.article>
  );
};

export default ThirtyDayCardMob;
